import * as Types from '../graphql.generated';

import { Internal_Links_FragmentFragment } from './internalLinks.fragment.generated';
import { Internal_Links_FragmentFragmentDoc } from './internalLinks.fragment.generated';
export type Seo_FragmentFragment = { __typename?: 'SeoResults' } & {
    redirection?: Types.Maybe<
        { __typename?: 'Redirection' } & Pick<Types.Redirection, 'code' | 'uri'>
    >;
    info?: Types.Maybe<
        { __typename?: 'SeoInfo' } & Pick<
            Types.SeoInfo,
            'canonicalUri' | 'areaName'
        > & {
                areaExpansions?: Types.Maybe<
                    Array<
                        { __typename?: 'SeoAreaExpansion' } & Pick<
                            Types.SeoAreaExpansion,
                            'level' | 'name' | 'url'
                        >
                    >
                >;
            }
    >;
    onPage?: Types.Maybe<
        { __typename?: 'OnPage' } & Pick<
            Types.OnPage,
            'description' | 'title' | 'robots' | 'heading'
        >
    >;
    breadcrumbs?: Types.Maybe<
        Array<
            { __typename?: 'Breadcrumbs' } & Pick<
                Types.Breadcrumbs,
                'label' | 'tracking' | 'uri' | 'i18nLabelKey' | 'noAppend'
            >
        >
    >;
    internalLinks?: Types.Maybe<
        { __typename?: 'InternalLinksByType' } & {
            currentlyAvailable?: Types.Maybe<
                {
                    __typename?: 'InternalLinks';
                } & Internal_Links_FragmentFragment
            >;
            townsAndCities?: Types.Maybe<
                {
                    __typename?: 'InternalLinks';
                } & Internal_Links_FragmentFragment
            >;
        }
    >;
};

export const Seo_FragmentFragmentDoc = `
    fragment SEO_FRAGMENT on SeoResults {
  redirection {
    code
    uri
  }
  info {
    canonicalUri
    areaName
    areaExpansions {
      level
      name
      url
    }
  }
  onPage {
    description
    title
    robots
    heading
  }
  breadcrumbs {
    label
    tracking
    uri
    i18nLabelKey
    noAppend
  }
  internalLinks {
    currentlyAvailable {
      ...INTERNAL_LINKS_FRAGMENT
    }
    townsAndCities {
      ...INTERNAL_LINKS_FRAGMENT
    }
  }
}
    ${Internal_Links_FragmentFragmentDoc}`;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {};
}
export type Sdk = ReturnType<typeof getSdk>;
